var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"z-form",attrs:{"tag":_vm.tag,"disabled":_vm.disabled},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var valid = ref.valid;
  var invalid = ref.invalid;
  var errors = ref.errors;
  var dirty = ref.dirty;
  var pending = ref.pending;
  var pristine = ref.pristine;
  var failed = ref.failed;
return [_vm._t("default",null,{"pending":pending,"dirty":dirty,"errors":errors,"valid":valid,"invalid":invalid,"pristine":pristine,"failed":failed})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }